import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { CS_BASE_URL } from '../utils/ProjectUrls';
import { AllRanges } from '../schemas/AllRanges';

const DEFINITION_PARAMETER_PATH = '/definition-parameters';

export const definitionParameterSlice = createApi({
    reducerPath: 'definition-parameters',

    baseQuery: fetchBaseQuery({ baseUrl: CS_BASE_URL }),

    endpoints: (builder) => ({
        getDefinitionParameterRanges: builder.query<
            AllRanges[],
            { ids: number[]; displayArea: string }
        >({
            query: ({ ids, displayArea }) => {
                const idsString = ids.join(',');
                return `${DEFINITION_PARAMETER_PATH}/${idsString}/parameters/ranges?displayArea=${displayArea}`;
            },
        }),
    }),
});

// 从definitionSlice中导出自动生成的hook
// Export the auto-generated hook from the definitionSlice
export const { useGetDefinitionParameterRangesQuery, useLazyGetDefinitionParameterRangesQuery } =
    definitionParameterSlice;
